export default "__VITE_ASSET__D0mz$ptD__"